module.exports = __webpack_public_path__ + "img/horizontal_4_7_4.89f06fd0.png";